import { Link } from 'react-router-dom';
import GameCard from '@/components/base/GameCard';
import { getHotGames } from '@/mocks/games';

export default function FeaturedGames() {
  const hotGames = getHotGames().slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              热门精选
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              经过千万玩家验证的独立游戏神作，每一款都值得你投入时间
            </p>
          </div>
          <Link
            to="/category/action-adventure"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {hotGames.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      </div>
    </section>
  );
}